export default "__VITE_ASSET__DsRJ8iLz__"